import { Box, Flex, Text, Tooltip } from "@chakra-ui/react";
import React from "react";
import { useFilteredRoutes } from "../../routes";
import { useUserAuth } from "utils/site";
import { SidebarBrand, SidebarLinks } from "./SidebarLinks";

const ROLE_LABELS = {
  administrador: "Administrador",
  profesor: "Profesor",
};

const getInitials = (user) => {
  const first = user.first_name?.trim()?.[0] || "";
  const last = user.last_name?.trim()?.[0] || "";
  if (first || last) {
    return `${first}${last}`.toUpperCase();
  }
  return (user.username || "").slice(0, 2).toUpperCase();
};

const SidebarContent = ({ onNavigate, collapsed = false }) => {
  const filteredRoutes = useFilteredRoutes();
  const { user } = useUserAuth();

  return (
    <Flex direction="column" h="100%" color="#fff">
      <SidebarBrand collapsed={collapsed} />
      <Box flex="1" overflowY="auto" overflowX="hidden" className="thin-scrollbar">
        <SidebarLinks routes={filteredRoutes} onNavigate={onNavigate} collapsed={collapsed} />
      </Box>
      {user && (
        <Tooltip
          label={collapsed ? `${user.first_name ? `${user.first_name} ${user.last_name || ""}`.trim() : user.username} · ${ROLE_LABELS[user.role] || user.role}` : ""}
          placement="right" isDisabled={!collapsed}
        >
          <Flex
            align="center"
            justify={collapsed ? "center" : "flex-start"}
            gap="11px"
            p="11px"
            mt="12px"
            borderRadius="14px"
            bg="rgba(255,255,255,.06)"
          >
            <Flex
              w="38px"
              h="38px"
              borderRadius="full"
              align="center"
              justify="center"
              fontWeight="700"
              fontSize="14px"
              color="#fff"
              flex="0 0 auto"
              bgGradient="linear(140deg, #7E63D6, #5A3FB5)"
            >
              {getInitials(user)}
            </Flex>
            {!collapsed && (
              <Box overflow="hidden">
                <Text fontWeight="700" fontSize="13.5px" color="#fff" noOfLines={1}>
                  {user.first_name
                    ? `${user.first_name} ${user.last_name || ""}`.trim()
                    : user.username}
                </Text>
                <Text fontSize="12px" color="#8E8178" fontWeight="600">
                  {ROLE_LABELS[user.role] || user.role}
                </Text>
              </Box>
            )}
          </Flex>
        </Tooltip>
      )}
    </Flex>
  );
};

export default SidebarContent;
